import { Immutable } from "immer";
import React from "react";

import { EditorContent } from "@thelabnyc/thelabui/src/components/EditorContent";

import { IMenuFooter } from "./menu.interface";

import styles from "./index.module.scss";

type IProps = Immutable<{
    navFooterEl: IMenuFooter;
}>;

const NavFooterComp = (props: IProps) => {
    return (
        <div className={styles.headerDropdownBtns}>
            <EditorContent>
                {(marker) => (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: props.navFooterEl.value.html,
                        }}
                        {...marker}
                    ></div>
                )}
            </EditorContent>
        </div>
    );
};

export default NavFooterComp;
